"use strict";
exports.__esModule = true;
exports.AI_CODE_NODE_BANNER_URL = exports.fieldList = void 0;
var fieldList = [
    {
        placeholder: 'Explain when the agent should use this action and what outcome it should achieve.The user desires to track the status of a package delivery\n\nExample:\nFetch a user’s order status using their order ID and return the latest delivery details.',
        label: {
            primaryText: 'What should this action do?',
            secondaryText: '',
        },
        value: '',
        isMultiline: true,
        error: '',
    },
    {
        placeholder: "Provide instructions for generating the Python code. Be specific about inputs, logic, validations, and expected output.\n\nExample:\nGenerate code that accepts `order_id` as input, calls the external API (for example,\nhttps://api.example.com/orders/{order_id}), handles API and validation errors gracefully, and returns a\nconcise, human-readable order status summary.",
        label: {
            primaryText: 'How should the code work?',
            secondaryText: '',
        },
        value: '',
        isMultiline: true,
        error: '',
        minHeight: '140px',
    },
];
exports.fieldList = fieldList;
var AI_CODE_NODE_BANNER_URL = 'https://toolassets.haptikapi.com/platform/assets/ai_code_node_banner.png';
exports.AI_CODE_NODE_BANNER_URL = AI_CODE_NODE_BANNER_URL;
